var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.state)?_c('div',{staticClass:"ais-GeoSearch"},[_c('GmapMap',{ref:"map",staticClass:"ais-GeoSearch-map",attrs:{"center":_vm.center,"zoom":_vm.zoom,"clickable":true,"options":_vm.options},on:{"zoom_changed":function($event){_vm.zoom = $event},"bounds_changed":_vm.boundsChanged}},[_c('GmapCluster',{attrs:{"zoom-on-click":true,"max-zoom":13,"grid-size":100,"styles":[
                {
                    textColor: 'white',
                    textSize: '14',
                    fontWeight: '700',
                    fontFamily: 'Gotham, Helvetica, sans-serif',
                    url: '/dist/images/clusters/size1.png',
                    height: 54,
                    width: 54
                },
                {
                    textColor: 'white',
                    textSize: '14',
                    fontWeight: '700',
                    fontFamily: 'Gotham, Helvetica, sans-serif',
                    url: '/dist/images/clusters/size2.png',
                    height: 62,
                    width: 62
                },
                {
                    textColor: 'white',
                    textSize: '14',
                    fontWeight: '700',
                    fontFamily: 'Gotham, Helvetica, sans-serif',
                    url: '/dist/images/clusters/size3.png',
                    height: 78,
                    width: 78
                },
                {
                    textColor: 'white',
                    textSize: '14',
                    fontWeight: '700',
                    fontFamily: 'Gotham, Helvetica, sans-serif',
                    url: '/dist/images/clusters/size4.png',
                    height: 94,
                    width: 94
                }
            ]}},_vm._l((_vm.$root.hits),function(item){return _c('GmapMarker',{key:item.id,attrs:{"position":item._geoloc,"clickable":true,"icon":_vm.getMarkerIcon(item)},on:{"click":function($event){return _vm.$emit('set-active-marker', item)}}})}),1),_vm._v(" "),(_vm.activeMarker && !_vm.$root.isMobile)?_c('GmapInfoWindow',{attrs:{"options":_vm.infoWindowOptions,"position":_vm.activeMarker._geoloc}}):_vm._e()],1),_vm._v(" "),(_vm.activeMarker && _vm.$root.isMobile)?[(_vm.$root.index == 'installers')?_c('MapViewInstaller',{staticClass:"ais-GeoSearch-mobilepopup",attrs:{"item":_vm.activeMarker},on:{"opened":_vm.scrollIntoView}}):_c('MapViewRetailer',{staticClass:"ais-GeoSearch-mobilepopup",attrs:{"item":_vm.activeMarker},on:{"opened":_vm.scrollIntoView}})]:_vm._e()],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }